<template>
  <div class="demo__flex demo__flex-column demo__margin-top--16">
    <div class="demo__flex demo__flex-column demo__gap--16">
      <p
        class="demo__font--16 demo__weight--400 demo__color--black demo__margin-bottom--0"
      >
        {{ $t("VerifyModal.step1.reason") }}
      </p>
      <div class="demo__flex demo__flex-column demo__gap--8">
        <div
          v-for="i in 3"
          :key="i"
          class="demo__flex demo__flex-row demo__gap--8"
        >
          <i
            class="fa-solid fa-check demo__color--brandPrimary demo__font--16"
          ></i>
          <span
            class="demo__font--16 demo__weight--400 demo__color--black demo__padding-bottom--0"
          >
            {{ $t("VerifyModal.step1.reasons." + i) }}
          </span>
        </div>
      </div>
      <p
        class="demo__padding-bottom--0 demo__font--16 demo__weight--400 demo__color--black"
      >
        {{ $t("VerifyModal.step1.end") }}
      </p>
    </div>
    <div
      v-if="!form.professional_status"
      class="demo__StatusChoose demo__flex demo__flex-column demo__margin-bottom--8"
    >
      <span
        class="demo__StatusChoose--required demo__font--16 demo__weight--400"
      >
        {{ $t("VerifyModal.step1.status") }}
      </span>
      <a-radio-group v-model="status" class="demo__VerifyModal--radioGroup">
        <a-radio
          v-for="option in options"
          :value="option.id"
          :key="option.id"
          >{{ option.name }}</a-radio
        >
      </a-radio-group>
    </div>
    <div class="demo__flex demo__flex-row demo__flex-end demo__margin-top--24">
      <a-button
        class="demo__button demo__button--base"
        @click="changeStepTo2"
        :disabled="nextStepDisabled"
        >{{ $t("To next")
        }}<i class="fa-solid fa-chevron-right demo__margin-left--8"></i
      ></a-button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: {
    form: {
      required: true,
      type: Object,
    },
    options: {
      required: false,
      type: Array,
    },
  },
  data() {
    return {
      status: undefined,
    };
  },
  computed: {
    ...mapGetters(["userLinks", "api", "verifyModalInfo"]),
    nextStepDisabled() {
      return !this.status && !this.form.professional_status;
    },
  },
  created() {
    this.$accessModule("VerifyModal_step1", this);
  },
  methods: {
    changeStepTo2() {
      if (this.status) {
        this.form.professional_status = this.status;
      }
      this.$root.$emit("changeVerifyStep", 2);
    },
  },
};
</script>
